import { render, staticRenderFns } from "./AuroRelease.vue?vue&type=template&id=694b30fc"
import script from "./AuroRelease.vue?vue&type=script&lang=js"
export * from "./AuroRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports